import { render, staticRenderFns } from "./AppointmentOnlineCard.vue?vue&type=template&id=f9bcebec&scoped=true&"
import script from "./AppointmentOnlineCard.vue?vue&type=script&lang=js&"
export * from "./AppointmentOnlineCard.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentOnlineCard.vue?vue&type=style&index=0&id=f9bcebec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bcebec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
